const WINDOWS_PRINT_KEY = 'pos_windows_print';

// The dedicated Windows shortcut sets this before login. Its Chrome profile
// supplies kiosk printing; a web page alone cannot disable browser dialogs.
export function initWindowsPrint() {
  const url = new URL(window.location.href);
  if (url.searchParams.get('windowsPrint') === '1') {
    localStorage.setItem(WINDOWS_PRINT_KEY, '1');
    url.searchParams.delete('windowsPrint');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  }
}
export const usesWindowsPrinter = () => localStorage.getItem(WINDOWS_PRINT_KEY) === '1';
export const printerMode = settings => usesWindowsPrinter() ? 'browser' : settings.mode || (settings.eth_ip ? 'ethernet' : 'browser');
